class NavTabs {
	constructor() {
		this.variables();
		// this.showFilter();
		this.bindEvents();
	}

	variables(){
		// this.mainSection = $('#winners');
		// this.filtersClass = $('.floating-filters');
	}

	bindEvents() {
		$(document).on('click', '.nav-tabs a', this.changeTabs);
		// $(window).on('scroll', this.showFilter.bind(this));
		if (window.location.hash != ''){
			$('.nav-tabs a[href="' + window.location.hash + '"]').trigger( "click" )
		}
	}

	changeTabs(e) {
		e.preventDefault();

		let target = $(this.hash);
		$(this).tab('show').after(function () {
			$('html, body').stop(true,false).animate({
				scrollTop: target.offset().top - 80
			}, 600);
		});

		$(this).on('shown.bs.tab', function () {
			$('html, body').stop(true,false).animate({
				scrollTop: target.offset().top - 80
			}, 600);
		});
	}

}